import React, { useEffect, useState } from 'react'
import { Checkbox, CheckboxGroup, Panel, Radio, RadioGroup, Rate, Row } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { cloneDeep, forEach, isEmpty } from 'lodash-es'
import InputCascaderForm from '../../components/forms/input/InputCascaderForm'
import InputMultiCascaderForm from '../../components/forms/input/InputMultiCascaderForm'
import { loadLocation } from '../../components/location/Location'
import PopoverMessages from '../../components/message/PopoverMessages'
import { isAssessmentLocation } from './RenderLocationTree'
import InputSelectForm from '../../components/forms/input/InputSelectForm'

export default function RenderAssessmentForm({
  assessments,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  resultKey = 'assessmentResult',
  setAssessmentResult = () => {},
  ...props
}) {
  const [result, setResult] = useState(new Map())
  const [location, setLocation] = useState([])

  const [uncheckableItems, setUncheckableItems] = useState([])

  useEffect(() => {
    let rs = new Map()

    let datas = appendAssessmentResult(assessments)

    datas?.forEach((e) => {
      rs.set(e.questionId, e.value)
    })

    if (isAssessmentLocation(assessments)) {
      handleLocation()
    }

    setResult(rs)
    setAssessmentResult(rs)
    setValue(resultKey, rs)
  }, [assessments])

  const handleLocation = async () => {
    // setLoading(true)
    let locationJson = await loadLocation()

    // let uncheckables = extractUncheckableItems(locationJson || [])
    // console.log('uncheckables : ', uncheckables)

    setLocation(locationJson || [])
    // setUncheckableItems(uncheckables || [])
    // setLoading(false)
  }

  // const extractUncheckableItems = (datas) => {
  //   const results = []

  //   datas?.forEach((e) => {
  //     if (Array.isArray(e.children)) {
  //       results.push(e.value)
  //       results.push(...extractUncheckableItems(e.children))
  //     }
  //   })

  //   return results
  // }

  const onChange = (key, value) => {
    // console.log('key : ', key, ', value', value)

    let rs = cloneDeep(result)
    if (value == null || value?.length === 0) {
      setValue(key, '')
      rs.delete(key)
    } else {
      rs.set(key, value + '')
    }

    setResult(rs)
    setAssessmentResult(rs)
    setValue(resultKey, rs)
  }

  const appendAssessmentResult = (datas) => {
    var result = []

    for (let item of datas) {
      if (!isEmpty(item.type) && !isEmpty(item.value)) {
        result.push({
          //id: item.id,
          questionId: item.name,
          value: Array.isArray(item.value) ? item.value.join(',') : item.value,
        })
      }

      if (item.options?.length > 0) {
        for (let option of item.options) {
          if (option.extends?.length > 0) {
            var extendsResult = appendAssessmentResult(option.extends)
            if (extendsResult.length > 0) {
              result.push(...extendsResult)
            }
          }
        }
      }

      if (item.children?.length > 0) {
        var childResult = appendAssessmentResult(item.children)
        if (childResult.length > 0) {
          result.push(...childResult)
        }
      }
    }

    return result
  }

  const renderAssessmentInput = (data) => {
    let obj = <></>
    let objName = `${data.name}`
    // if (parentKey) {
    //   objName = `${parentKey}_${data.name}`
    // }

    switch (data.type) {
      case '1':
        obj = (
          <>
            <ErrorMessage error={errors[objName]} />
            <Controller
              name={objName}
              control={control}
              rules={isValidators(data.validators)}
              //defaultValue={result.get(objName)}
              defaultValue={data.value}
              render={(props) => {
                return (
                  <RadioGroup
                    name={objName}
                    //defaultValue={result.get(objName)}
                    //value={result.get(objName)}
                    defaultValue={data.value}
                    onChange={(value) => {
                      props.onChange(value)
                      onChange(objName, value)
                    }}
                  >
                    {data.options.map((item, index) => {
                      return (
                        <>
                          <Radio key={item.value} value={item.value}>
                            <p
                              dangerouslySetInnerHTML={{ __html: item.label }}
                              style={{ marginTop: -3 }}
                            />
                          </Radio>
                          {result.get(objName)?.includes(item.value) &&
                            item.extends?.length > 0 && (
                              <div style={{ marginLeft: 30 }}>
                                {renderAssessment(item.extends, true)}
                              </div>
                            )}
                        </>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
          </>
        )
        break
      case '2':
        obj = (
          <>
            <ErrorMessage error={errors[objName]} />
            <Controller
              name={objName}
              control={control}
              rules={isValidators(data.validators)}
              defaultValue={data.value}
              render={(props) => {
                return (
                  // <CheckboxGroup
                  //   name={objName}
                  //   defaultValue={data.value}
                  //   onChange={(value) => {
                  //     let val = value?.filter(
                  //       (e) => Object.prototype.toString.call(e) !== '[object Object]'
                  //     )
                  //     //console.log('value : ', val)

                  //     props.onChange(val)
                  //     onChange(objName, val)
                  //   }}
                  // >
                  <>
                    {data.options.map((item, index) => {
                      return (
                        <>
                          <Checkbox
                            key={item.value}
                            value={item.value}
                            checked={result.get(objName)?.includes(item.value)}
                            onChange={(key, check) => {
                              let rs = result.get(objName)?.split(',') || []
                              //console.log('rs : ', rs)

                              if (check) {
                                rs.push(key)
                              } else {
                                rs = rs.filter((e) => e !== key)
                              }

                              //console.log('rs ds : ', rs)
                              props.onChange(rs)
                              onChange(objName, rs.join(','))
                            }}
                          >
                            <p
                              dangerouslySetInnerHTML={{ __html: item.label }}
                              style={{ marginTop: -3 }}
                            />
                          </Checkbox>
                          {result.get(objName)?.includes(item.value) &&
                            item.extends?.length > 0 && (
                              <div style={{ marginLeft: 30 }}>
                                {renderAssessment(item.extends, true)}
                              </div>
                            )}
                        </>
                      )
                    })}
                  </>

                  // </CheckboxGroup>
                )
              }}
            />
          </>
        )
        break
      case '3':
        obj = (
          <InputForm
            hideLabel
            schema={data}
            name={objName}
            rows={4}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onChange={(value) => {
              onChange(objName, value)
            }}
          />
        )

        break
      case '4':
        obj = (
          <InputForm
            hideLabel
            schema={data}
            name={objName}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onChange={(value) => {
              onChange(objName, value)
            }}
          />
        )
        break
      case '5':
        obj = (
          <InputForm
            isInputNumber
            hideLabel
            schema={data}
            name={objName}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onChange={(value) => {
              onChange(objName, value)
            }}
          />
        )
        break
      case '6':
        if (data.maximum > 0) {
          obj = (
            <Row style={{ textAlign: 'center' }}>
              <>
                <ErrorMessage error={errors[objName]} />
                <Controller
                  name={objName}
                  control={control}
                  rules={isValidators(data.validators)}
                  defaultValue={data.value}
                  render={(props) => {
                    return (
                      <Rate
                        defaultValue={data.value ? parseInt(data.value) : 0}
                        max={data.maximum}
                        classPrefix="rs-rate rs-rate-size-xl"
                        //value={data.selection.value || 0}
                        onChange={(value) => {
                          props.onChange(value)
                          onChange(objName, value)
                        }}
                      />
                    )
                  }}
                />
              </>
            </Row>
          )
        }
        break
      case '7':
        obj = (
          <InputCascaderForm
            hideLabel
            schema={data}
            name={objName}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            cascaderDatas={location}
            onChange={(value) => {
              onChange(objName, value)
            }}
          />
        )
        break
      case '8':
        obj = (
          <InputMultiCascaderForm
            hideLabel
            schema={data}
            name={objName}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            cascaderDatas={location}
            uncheckableItems={uncheckableItems}
            onChange={(value) => {
              onChange(objName, value)
            }}
          />
        )
        break
      case '9':
        obj = (
          <InputSelectForm
            hideLabel
            schema={data}
            name={objName}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onChange={(value) => {
              onChange(objName, value)
            }}
          />
        )
        break
      default:
        break
    }
    return obj
  }

  const renderAssessment = (datas, isTab) => {
    return (
      <>
        {datas?.map((data, index) => {
          return (
            <Panel
              bordered
              key={data.id}
              style={{
                marginBottom: 15,
                marginLeft: isTab ? 10 : 0,
                borderColor: result.get(data.name) ? '#2da888' : undefined,
              }}
              collapsible
              defaultExpanded
              header={
                <div>
                  {requiredFiled(data.validators, `${data.label}`)}
                  <PopoverMessages content={data.note} />
                </div>
              }
            >
              {renderAssessmentInput(data)}

              {data.children?.length > 0 && renderAssessment(data.children, true)}
            </Panel>
          )
        })}
      </>
    )
  }

  return (
    <div>
      <Controller
        key={resultKey}
        name={resultKey}
        control={control}
        defaultValue={result}
        value={result}
      />

      {renderAssessment(assessments || [], false)}
    </div>
  )
}
